import React, { useContext, useEffect, useRef } from 'react'
import Progress from './Progress'
import ProgressCtx from './contexts/Progress'
import GlobalContext from './contexts/Global'
import StoriesContext from './contexts/Stories'

export default () => {
    const { currentId, next, videoDuration, pause, count, setCount, progressMode, storyCycle } =
        useContext(ProgressCtx)
    const { defaultInterval, onStoryEnd, onStoryStart } = useContext(GlobalContext)
    const { stories } = useContext(StoriesContext)
    const animationFrameIdRef = useRef(0)
    const lastTimeRef = useRef(null)
    const completionKeyRef = useRef('')
    const startedKeyRef = useRef('')

    const currentStory = stories[currentId]
    const currentKey = `${currentId}:${storyCycle}`

    useEffect(() => {
        lastTimeRef.current = null
        completionKeyRef.current = ''
        startedKeyRef.current = ''
    }, [currentKey])

    useEffect(() => {
        if (!currentStory || startedKeyRef.current === currentKey) return
        startedKeyRef.current = currentKey
        onStoryStart?.(currentId, currentStory)
    }, [currentId, currentKey, currentStory, onStoryStart])

    useEffect(() => {
        if (!currentStory || progressMode !== 'timer' || pause) {
            cancelAnimationFrame(animationFrameIdRef.current)
            lastTimeRef.current = null
            return
        }

        const interval =
            currentStory.type === 'video' || currentStory.trackDuration
                ? videoDuration || currentStory.duration || defaultInterval
                : currentStory.duration || defaultInterval

        if (!Number.isFinite(interval) || interval <= 0) return

        const tick = now => {
            if (pause) return

            const lastTime = lastTimeRef.current
            lastTimeRef.current = now

            if (lastTime != null) {
                const elapsed = now - lastTime
                setCount(previousCount => Math.min(100, previousCount + (elapsed / interval) * 100))
            }

            animationFrameIdRef.current = requestAnimationFrame(tick)
        }

        animationFrameIdRef.current = requestAnimationFrame(tick)

        return () => {
            cancelAnimationFrame(animationFrameIdRef.current)
        }
    }, [currentKey, currentStory, defaultInterval, pause, progressMode, setCount, videoDuration])

    useEffect(() => {
        if (!currentStory || count < 100) return
        if (completionKeyRef.current === currentKey) return

        completionKeyRef.current = currentKey
        onStoryEnd?.(currentId, currentStory)
        next()
    }, [count, currentId, currentKey, currentStory, next, onStoryEnd])

    const styles = {
        progressArr: {
            display: 'flex',
            justifyContent: 'center',
            maxWidth: '100%',
            flexWrap: 'row',
            position: 'absolute',
            width: '98%',
            padding: 5,
            paddingTop: 7,
            alignSelf: 'center',
            zIndex: 99,
            filter: 'drop-shadow(0 1px 8px #222)',
        },
    }

    return React.createElement(
        'div',
        { style: styles.progressArr },
        stories.map((_, i) =>
            React.createElement(Progress, {
                key: i,
                count,
                width: 1 / stories.length,
                active: i === currentId ? 1 : i < currentId ? 2 : 0,
            }),
        ),
    )
}
